import Visitable from "../../../shared/interfaces/visitable.ts";
import { logError } from "@Resources/js/helpers/logger.js";

export interface Tag extends Visitable<Tag> {
    name: string;
}

export default function TagModel(name: string): Tag {
    let visitOverride: ((model: Tag, query?: Record<string, string>) => void) | null = null;

    const that: Tag = {
        name,

        visit(query = {}) {
            if (visitOverride) {
                visitOverride(that, query);
            } else {
                logError(`No route has been set for tag "${name}"`);
            }
        },

        setVisit(callback) {
            visitOverride = callback;
            return that;
        },
    };

    return that;
}
